import React, { CSSProperties } from 'react';

interface BookProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const Book: React.FC<BookProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M225,309.5s62.5-62,187.5,0l125,62v438s-125-62.5-187.5-62.5h-125v-437.5Z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
      <path d="M850,309.5s-62.5-62-187.5,0l-125,62v438s125-62.5,187.5-62.5c62.5,0,125,0,125,0v-437.5Z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
    </svg>
  );
};

export default Book;
